import React, { useEffect, useState } from "react";
import { Mail, Instagram } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import { usePageTitle, SectionTitle } from "../components/common";

export default function Contact() {
  usePageTitle("Contact");
  const [settings, setSettings] = useState({});
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    subject: "",
    message: "",
    website: "",
  });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Ton message a bien été envoyé ✨");
      setForm({ first_name: "", last_name: "", email: "", subject: "", message: "", website: "" });
    } catch {
      toast.error("Une erreur est survenue. Réessaie dans un instant.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="home-dark min-h-[80vh]">
      <div className="container-x py-12 sm:py-20 fade-up">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <SectionTitle eyebrow="Prendre contact" title="Écris-moi" />
            <p className="mt-6 text-[#E7DCEA] leading-relaxed">
              Une question avant de réserver ? N'hésite pas à m'écrire, je te réponds avec douceur.
            </p>
            <div className="mt-8 space-y-4">
              {settings.contact_email && (
                <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-3 text-[#F3E9DE] hover:text-[#DFC07B] transition-colors">
                  <span className="w-10 h-10 rounded-full bg-[#C9A56A]/20 flex items-center justify-center shrink-0">
                    <Mail size={18} className="text-[#DFC07B]" />
                  </span>
                  <span className="text-sm break-all">{settings.contact_email}</span>
                </a>
              )}
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-[#F3E9DE] hover:text-[#DFC07B] transition-colors">
                  <span className="w-10 h-10 rounded-full bg-[#C9A56A]/20 flex items-center justify-center shrink-0">
                    <Instagram size={18} className="text-[#DFC07B]" />
                  </span>
                  <span className="text-sm">Instagram</span>
                </a>
              )}
            </div>
          </div>

          <form onSubmit={submit} className="lg:col-span-3 card-soft p-7 space-y-4" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="field-label">Prénom</label>
                <input required className="field-input" value={form.first_name} onChange={set("first_name")} data-testid="contact-first-name" />
              </div>
              <div>
                <label className="field-label">Nom</label>
                <input required className="field-input" value={form.last_name} onChange={set("last_name")} data-testid="contact-last-name" />
              </div>
            </div>
            <div>
              <label className="field-label">Email</label>
              <input required type="email" className="field-input" value={form.email} onChange={set("email")} data-testid="contact-email" />
            </div>
            <div>
              <label className="field-label">Objet</label>
              <input required className="field-input" value={form.subject} onChange={set("subject")} data-testid="contact-subject" />
            </div>
            <div>
              <label className="field-label">Message</label>
              <textarea required rows={5} className="field-input resize-none" value={form.message} onChange={set("message")} data-testid="contact-message" />
            </div>
            {/* honeypot */}
            <input
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={form.website}
              onChange={set("website")}
              className="hidden"
              aria-hidden="true"
            />
            <button type="submit" disabled={sending} className="btn-primary w-full" data-testid="contact-submit">
              {sending ? "Envoi…" : "Envoyer mon message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
